<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8562_75329)">
      <path
        d="M10 20.2468C15.5228 20.2468 20 15.7697 20 10.2468C20 4.72398 15.5228 0.246826 10 0.246826C4.47715 0.246826 0 4.72398 0 10.2468C0 15.7697 4.47715 20.2468 10 20.2468Z"
        fill="#039BE5"
      />
      <path
        d="M4.57556 10.0301L14.2172 6.31265C14.6647 6.15098 15.0556 6.42182 14.9106 7.09848L14.9114 7.09765L13.2697 14.8318C13.1481 15.3801 12.8222 15.5135 12.3664 15.2551L9.8664 13.4126L8.66056 14.5743C8.52723 14.7077 8.41473 14.8202 8.1564 14.8202L8.3339 12.276L12.9672 8.09015C13.1689 7.91265 12.9222 7.81265 12.6564 7.98932L6.93056 11.5943L4.46223 10.8243C3.9264 10.6543 3.91473 10.2885 4.57556 10.0301Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_8562_75329">
        <rect width="20" height="20" fill="white" transform="translate(0 0.246826)" />
      </clipPath>
    </defs>
  </svg>
</template>
